import { apiFetch } from './client';
import type { DashboardSettings } from './types';

export interface UpdateSettingsParams {
  backupsConfigured?: boolean;
  immutableAuditConfigured?: boolean;
  trustCenterPublished?: boolean;
  rateLimitPerMin?: number;
  retentionDays?: number;
  routeMiniBand?: number;
  routeFullBand?: number;
  nextMilestone?: string;
}

// The PATCH response is the raw OrgSettings row (a superset of DashboardSettings).
export const updateSettings = (patch: UpdateSettingsParams) =>
  apiFetch<DashboardSettings>('/settings', {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });

export const reviewRequest = (id: string, decision: 'acknowledged' | 'dismissed') =>
  apiFetch<{ id: string; reviewStatus: string }>(`/audit/requests/${id}/review`, {
    method: 'POST',
    body: JSON.stringify({ decision }),
  });
